// extracted by mini-css-extract-plugin
module.exports = {"summaryPoint":"SummaryPoint_summaryPoint__3I2dZ","icon":"SummaryPoint_icon__2jOdY","content":"SummaryPoint_content__2F0OF"};